//import InstagramIcon from 'assets/images/socials/instagram.svg?react';
import LinkedinIcon from 'assets/images/socials/linkedin.svg?react';
//import TiktokIcon from 'assets/images/socials/tiktok.svg?react';
import { EInternalLinks } from 'shared/typings';

export const SOCIALS = [
	/*{ icon: <InstagramIcon />, link: 'https://instagram.com', key: 'instagram' },
  { icon: <TiktokIcon />, link: 'https://tiktok.com', key: 'tiktok' },*/
	{ icon: <LinkedinIcon />, link: EInternalLinks.LINKEDIN, key: 'linkedin' },
];
